import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReportTypeEnum } from '../../util/reports';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private url = environment.backendImmoReport + "/reports";

  constructor(
    private http: HttpClient) { }

  getPDFFile(reportType, JSONRequest, format: string = 'pdf'): Observable<Object> {
    console.log('Generating PDF report', { 
      reportType, 
      JSONRequest, 
      format,
      url: this.url 
    });

    try {
      switch (reportType) {
        case ReportTypeEnum.ReportType_Inventory:
          return this.http.post<Object>(this.url + '/empty-inventory', JSONRequest, {
            ...httpOptions,
            observe: 'body',
            responseType: 'json'
          });
        case ReportTypeEnum.ReportType_RentingContract:
          return this.http.post<Object>(this.url + '/empty-rental-contract', JSONRequest, {
            ...httpOptions,
            observe: 'body',
            responseType: 'json'
          });
        case ReportTypeEnum.ReportType_SubRentingContract:
          return this.http.post<Object>(this.url + '/empty-subrental-contract', JSONRequest, {
            ...httpOptions,
            observe: 'body',
            responseType: 'json'
          });
        case ReportTypeEnum.ReportType_End_RentingContract:
          return this.http.post<Object>(this.url + '/empty-end-rental-contract', JSONRequest, {
            ...httpOptions,
            observe: 'body',
            responseType: 'json'
          });
        case ReportTypeEnum.ReportType_BeneficiarRealContract:
          return this.http.post<Object>(this.url + '/empty-beneficiar-real-contract', JSONRequest, {
            ...httpOptions,
            observe: 'body',
            responseType: 'json'
          });
        case ReportTypeEnum.ReportType_AcordGDPR:
          return this.http.post<Object>(this.url + '/empty-acord-gdpr', JSONRequest, {
            ...httpOptions,
            observe: 'body',
            responseType: 'json'
          });
        case 4: // Assuming this is another specific report type
          return this.http.post<Object>(this.url + '/empty-end-contract', JSONRequest, {
            ...httpOptions,
            observe: 'body',
            responseType: 'json'
          });
        default:
          console.error('Unknown report type', { reportType });
          return of(null);
      }
    } catch (error) {
      console.error('Error in getPDFFile', { 
        error, 
        reportType, 
        url: this.url 
      });
      return of(null);
    }
  }

  // getPDFFile(reportType: ReportTypeEnum, dataType: any, format: string = 'pdf'): Observable<any> {
  //   const params = new HttpParams()
  //     .set('reportType', reportType.toString())
  //     .set('format', format);

  //   return this.http.post(this.apiUrl + '/reports/generate', dataType, { 
  //     params,
  //     responseType: 'blob',
  //     observe: 'response'
  //   });
  // }
}
